import { TrendingUp, DollarSign, Users, KeyRound } from 'lucide-react';
import { OwnerInbox } from './OwnerInbox';

export default function OwnerKpiStrip({ user, property }) {
  if ((user?.pm_sub_role || '').trim().toLowerCase() !== 'owner') return null;
  const occupancy = typeof property?.occupancy_pct === 'number' ? `${Math.round(property.occupancy_pct)}%` : typeof property?.occupied_units === 'number' && property?.total_units > 0 ? `${Math.round(property.occupied_units / property.total_units * 100)}%` : '—';
  const revenue = property?.mtd_revenue ?? property?.monthly_revenue;
  const tiles = [
    ['occupancy', 'Occupancy', occupancy, TrendingUp],
    ['revenue', 'MTD Revenue', typeof revenue === 'number' ? `$${revenue.toLocaleString()}` : '—', DollarSign],
    ['units', 'Unit Count', property?.unit_count ?? property?.total_units ?? '—', Users],
    ['code', 'Property / Facility ID', property?.necs_code || property?.property_code || '—', KeyRound],
  ];
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-6 min-w-0" data-testid="owner-kpi-strip">
    {tiles.map(([key, label, value, Icon]) => <div key={key} className="p-4 min-w-0 rounded-lg bg-zinc-950 border border-[#C9A962]/40 text-white" data-testid={`owner-kpi-${key}`}>
      <div className="flex justify-between gap-2 mb-3 text-xs font-bold text-[#C9A962]">{label}<Icon size={18} className="shrink-0" /></div>
      <div className={`${key === 'code' ? 'text-base font-mono' : 'text-2xl'} font-bold text-[#FFD60A] break-words [overflow-wrap:anywhere]`} data-testid={`owner-kpi-${key}-value`}>{value}</div>
    </div>)}
    <OwnerInbox />
  </div>;
}